/* eslint-disable import/prefer-default-export */

export const FILE_MAX_SIZE_MB = 50;
